import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './guards/auth.guard';
import { AuthService } from './services/auth.service';
import { DatabaseService } from './services/database.service';
import { CloudinaryService } from './services/cloudinary.service';

@NgModule({
  imports: [CommonModule],
  providers: [AuthGuard, AuthService, DatabaseService, CloudinaryService]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule?: CoreModule) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import it only once in AppModule.');
    }
  }
}
